<template>
    <section class="mod">
        <!-- <h2 class="mod-tit">
            历史南向数据
            <router-link class="fr link-more" :to="'/historylist'">
                查看更多
            </router-link>
        </h2> -->
        <h2 class="mod-tit">
            历史明细（净买额）
            <router-link class="fr link-more-btn" :to="'/historylist'">&ensp;更多</router-link></h2>
        <div class="table-scroll">
            <div class="table-l fl">
                <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                        <th>日期</th>
                    </tr>
                    <tr
                        v-for="(item,index) in dataInfo.slice(0, 10)"
                        :key="index"
                    >
                        <td>{{ item.riqi }}</td>
                    </tr>
                </table>
            </div>
            <div class="table-r">
                <div class="table-r-wrap">
                    <table width="100%" cellspacing="0" cellpadding="0">
                        <tr>
                            <th>港股通(沪)</th>
                            <th>港股通(深)</th>
                            <th>合计</th>
                        </tr>
                         <tr
                            v-for="(item,index) in dataInfo.slice(0, 10)"
                            :key="index"
                        >
                            <td :class="item.jiage_s | formateRedGreen">
                                {{ item.jiage_s }}亿
                            </td>
                            <td :class="item.jiage_h | formateRedGreen">
                                {{ item.jiage_h }}亿
                            </td>
                            <td :class="item.jiage_hj | formateRedGreen">
                                {{ item.jiage_hj }}亿
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
// 获取历史南向数据
import { bxzjLsmx } from "@/api/lszx.js";

export default {
    name: "HistoryNorthData",
    data() {
        return {
            historyNorthData: [
                {
                    id: 0,
                    date: "2022-01-06",
                    hgt: "-22.17",
                    ggt: "+16.38",
                    total: "-125.30",
                },
                {
                    id: 1,
                    date: "2022-01-06",
                    hgt: "-22.17",
                    ggt: "+16.38",
                    total: "-125.30",
                },
                {
                    id: 2,
                    date: "2022-01-06",
                    hgt: "-22.17",
                    ggt: "+16.38",
                    total: "-125.30",
                },
            ],
              dataInfo:[],
        };
    },
    filters: {
        formateTag: function (v) {
            if (v == undefined || v == null) return;
            if (v > 0) return "交易中";
            if (v < 0) return "已结束";
        },
        formatePrefixData: function (v) {
            if (v == undefined || v == null) return "--";
            if (v > 0) return "+" + v;
            if (v < 0) return v;
        },
        formateRedGreen: function (v) {
            if (v == undefined || v == null) return;
            if (v > 0) return "ft-red";
            if (v < 0) return "ft-green";
        },
    },
    mounted: function () {
        this.getLssj();
    },
    methods: {
        getLssj: function () {
            var _this = this;
            var params = {
                type: "2",
                page: "1",
                size: "10",
            };
            bxzjLsmx(params).then((res) => {
                if (res.data.err == 0) {
                    _this.dataInfo = res.data.data.list;
                } else {
                    _this.dataInfo = [];
                }
            });
        },
    },
};
</script>
